import { Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { RouterStateSnapshot, TitleStrategy as AngularTitleStrategy, ActivatedRouteSnapshot } from "@angular/router";

@Injectable()
export class TitleStrategy extends AngularTitleStrategy {
	constructor(
		private readonly _title: Title
	) {
		super();
	}

	public override buildTitle(routerStateSnapshot: RouterStateSnapshot): string {
		let activatedRouteSnapshot: ActivatedRouteSnapshot = routerStateSnapshot.root;

		while (activatedRouteSnapshot.firstChild) {
			activatedRouteSnapshot = activatedRouteSnapshot.firstChild;
		}

		return activatedRouteSnapshot.parent.title;
	}

	public override updateTitle(routerStateSnapshot: RouterStateSnapshot) {
		const title = this.buildTitle(routerStateSnapshot);
		
		if (title !== undefined) {
			this._title.setTitle(`${title}`);
		}
	}
}